import { __assign, __rest } from "tslib";
import * as Styles from './footer-pattern.styled';
import { DisplayType, TypeToledo } from '@at/design-system-foundation';
import { BackToTop } from '@at/design-system-elements';
import React, { useEffect, useState } from 'react';
import { Accordion } from '../accordion/accordion';
import { Channel } from '@at/sauron-platform-core/lib/types';
import { FooterBikesLinks } from './data/bikes/bikes-links';
import { FooterCarsLinks } from './data/cars/cars-links';
import { FooterColumnSection } from './components/links/footer-links';
import { FooterFarmLinks } from './data/farm/farm-links';
import { FooterLink } from './components/links/footer-link';
import { FooterNavCompany } from './components/company-info/footer-company-info';
import { FooterPlantLinks } from './data/plant/plant-links';
import { FooterTrucksLinks } from './data/trucks/trucks-links';
import { FooterVansLinks } from './data/vans/vans-links';
import { Logo } from '@at/design-system-elements';
import { actionLinks } from './data/footer-shared-links';
import { addCmpV2 } from './cmp';
import { useAppContext } from '@at/sauron-platform-core/lib/app/app-context.hoc';
import { FooterMotorhomesLinks } from './data/motorhomes/motorhomes-links';
import { FooterCaravansLinks } from './data/caravans/caravans-links';
import { FooterSocialIcons } from './footer-pattern.styled';
var profilePageUrlPattern = new RegExp('^/dealers/(?:[a-zA-Z-]*/){0,2}.+-[0-9]+$|^/retailer/(?:[a-zA-Z-]*/){0,2}.*-?[0-9]+$');
var openReviewPageUrlPattern = new RegExp('^/services/car-dealers/write-an-open-review.*$');
export var usabillaInteractionHandler = function (abTestGroups, platform, userId, isUserSignedIn) {
    if (typeof document === 'undefined' && window === undefined) {
        return null;
    }
    else if (window.usabilla_live !== undefined) {
        window.usabilla_live('click');
    }
    else {
        var abTestGroupsParam = abTestGroups.length > 0 ? "&ABTestAllocation=".concat(abTestGroups.join('-')) : '';
        var userIdParam = userId ? "&userid=".concat(userId) : '';
        var isUserSignedInParam = "&logged_in_status=".concat(isUserSignedIn ? 'signed-in' : 'not-signed-in');
        var useDealerReviewsSurvey = profilePageUrlPattern.test(window.location.pathname) ||
            openReviewPageUrlPattern.test(window.location.pathname);
        var surveyId = void 0;
        if (platform === 'desktop') {
            if (useDealerReviewsSurvey) {
                surveyId = '66b4d79e36d0df4be5743c8b';
            }
            else {
                surveyId = '61dc55f256b1187790030a31';
            }
        }
        else {
            if (useDealerReviewsSurvey) {
                surveyId = '66b4d79e36d0df4be5743c89';
            }
            else {
                surveyId = '61dc562073f07d2bf414d5af';
            }
        }
        var surveyUrl = "http://survey.usabilla.com/live/s/".concat(surveyId, "?url=").concat(encodeURIComponent(window.location.href), "&platform=").concat(platform).concat(abTestGroupsParam).concat(userIdParam).concat(isUserSignedInParam);
        window.open(surveyUrl, '_blank');
    }
};
function splitLinkData(data) {
    var ATGroupLinks = data[0], channelLinks = data.slice(1);
    return {
        ATGroupLinks: ATGroupLinks,
        channelLinks: channelLinks,
    };
}
export var Footer = function (_a) {
    var platform = _a.platform, channel = _a.channel, _b = _a.showFeedbackButton, showFeedbackButton = _b === void 0 ? true : _b, trackingCallbacks = _a.trackingCallbacks, otherHTMLProperties = __rest(_a, ["platform", "channel", "showFeedbackButton", "trackingCallbacks"]);
    var _c = useAppContext(), _d = _c.abTestGroups, abTestGroups = _d === void 0 ? [] : _d, _e = _c.isUserSignedIn, isUserSignedIn = _e === void 0 ? function () { return false; } : _e, _f = _c.userId, userId = _f === void 0 ? '' : _f;
    var linkData = useState(function () {
        switch (channel) {
            case Channel.vans:
                return splitLinkData(FooterVansLinks());
            case Channel.bikes:
                return splitLinkData(FooterBikesLinks());
            case Channel.caravans:
                return splitLinkData(FooterCaravansLinks());
            case Channel.motorhomes:
                return splitLinkData(FooterMotorhomesLinks());
            case Channel.trucks:
                return splitLinkData(FooterTrucksLinks());
            case Channel.plant:
                return splitLinkData(FooterPlantLinks());
            case Channel.farm:
                return splitLinkData(FooterFarmLinks());
            case Channel.cars:
            default:
                return splitLinkData(FooterCarsLinks());
        }
    })[0];
    useEffect(function () { return addCmpV2(); }, []);
    return (React.createElement(Styles.Footer, __assign({ id: "footer", role: "contentinfo", "data-testid": "footer" }, otherHTMLProperties),
        React.createElement(BackToTop, null),
        React.createElement(Styles.FooterNav, null,
            React.createElement(Styles.FooterContainer, { displayType: DisplayType.CONSTRAINED },
                React.createElement(Styles.FooterHeader, null,
                    React.createElement(Logo, { channel: channel })),
                React.createElement(Styles.FooterRow, null,
                    React.createElement(Styles.FooterColumn, null,
                        React.createElement(Styles.FooterLinksGroup, null,
                            linkData.ATGroupLinks && (React.createElement(Styles.GroupLinksColumn, null,
                                React.createElement(TypeToledo, { as: "h3", className: "group-links-header" }, linkData.ATGroupLinks.rowHeading),
                                React.createElement(FooterColumnSection, { subNav: linkData.ATGroupLinks.subNav, trackingCallback: trackingCallbacks === null || trackingCallbacks === void 0 ? void 0 : trackingCallbacks.onFooterLinkClick }))),
                            linkData.channelLinks && (React.createElement(Accordion, { trackingCallback: trackingCallbacks === null || trackingCallbacks === void 0 ? void 0 : trackingCallbacks.onAccordionClick, items: linkData.channelLinks.map(function (_a, index) {
                                    var rowHeading = _a.rowHeading, subNav = _a.subNav;
                                    return {
                                        rowIndex: index,
                                        rowHeading: rowHeading,
                                        rowContent: (React.createElement(FooterColumnSection, { subNav: subNav, trackingCallback: trackingCallbacks === null || trackingCallbacks === void 0 ? void 0 : trackingCallbacks.onFooterLinkClick })),
                                    };
                                }) })))),
                    React.createElement(Styles.FooterColumn, { className: "apps-and-legal" },
                        showFeedbackButton && (React.createElement("section", null,
                            React.createElement(Styles.FeedbackHeader, { as: "p" }, "Help us improve our website"),
                            React.createElement(Styles.FeedbackButton, { text: "Send feedback", displayType: "secondary", onInteraction: function () {
                                    return usabillaInteractionHandler(abTestGroups, platform, userId, isUserSignedIn());
                                }, trackingCallback: trackingCallbacks === null || trackingCallbacks === void 0 ? void 0 : trackingCallbacks.onFeedbackClick }))),
                        React.createElement(FooterSocialIcons, { trackingCallback: trackingCallbacks === null || trackingCallbacks === void 0 ? void 0 : trackingCallbacks.onSocialClick }),
                        React.createElement(Styles.FooterActionLinks, null, actionLinks.map(function (action, i) {
                            return (React.createElement(FooterLink, __assign({ key: "footerActionSubNav".concat(i), href: action.url, icon: action.icon, svgProps: action.svgProps, title: action.title, trackingCallback: trackingCallbacks === null || trackingCallbacks === void 0 ? void 0 : trackingCallbacks.onFooterLinkClick }, action.attributes)));
                        })),
                        React.createElement(FooterNavCompany, { trackingCallback: trackingCallbacks === null || trackingCallbacks === void 0 ? void 0 : trackingCallbacks.onCompanyInfoClick })))))));
};
